import { render, staticRenderFns } from "./CreatorCommentsDrawer.vue?vue&type=template&id=6c818eaf&scoped=true"
import script from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js"
export * from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js"
import style0 from "./CreatorCommentsDrawer.vue?vue&type=style&index=0&id=6c818eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c818eaf",
  null
  
)

export default component.exports